import React from "react";
import { Card, Row, Col, Typography, Button, Empty, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import useTrainings from "PlatForms/OrgLMS/Hooks/LearnerHooks/useTraining";
const { Title, Text, Paragraph } = Typography;
const CompletedTraining = () => {
  const navigate = useNavigate();
  const learnerId = localStorage.getItem("personalId");
  const token = localStorage.getItem("token");
  const { trainingData, loading } = useTrainings(learnerId, token, true);
  return (
    <Card
      title="Completed Trainings"
      loading={loading}
      className="card-professional"
      style={{ maxHeight: "80vh", overflowY: "auto", borderRadius: 12 }}
      extra={
        <Button type="default" onClick={() => navigate("/training")}>
          Back
        </Button>
      }
    >
      {trainingData.length === 0 && !loading ? (
        <div style={{ textAlign: "center", padding: "50px 0" }}>
          <Empty description="No Completed Trainings Available" />
        </div>
      ) : (
        <Row gutter={[24, 24]}>
          {trainingData.map((training) => (
            <Col xs={24} sm={12} md={8} lg={8} key={training.id}>
              <div style={{ position: "relative", marginBottom: 20 }}>
                {training.isRetryTraining && <div className="ribbon-Badge">Repeated</div>}
                <Card
                  variant="borderless"
                  style={{
                    borderRadius: "12px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    height: "100%",
                  }}
                >
                  <Title level={4} style={{ marginBottom: 24 }}>
                    {training.title}
                  </Title>
                  <Paragraph type="secondary">{training.description}</Paragraph>
                  <Text strong>Group:</Text> <Text>{training.groupName}</Text>
                  <br />
                  <Text strong>Mentor ID:</Text> <Text>{training.mentorId}</Text>
                  <br />
                  <Text strong>Start:</Text>{" "}
                  <Text>{moment(training.startDate).format("MMM D, YYYY")}</Text>
                  <br />
                  <Text strong>End:</Text>{" "}
                  <Text>{moment(training.endDate).format("MMM D, YYYY")}</Text>
                  <br />
                  <br />
                  <Tag style={{ backgroundColor: "Green", color: "white" }}>Status : Completed</Tag>
                </Card>
              </div>
            </Col>
          ))}
        </Row>
      )}
    </Card>
  );
};
export default CompletedTraining;
